import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, useTheme } from '@mui/material';
import Sidebar from './admincomponents/Sidebar';
import Navbar from './admincomponents/Navbar';
import Dashboard from './adminpages/Dashboard';
import UserManagement from './adminpages/UserManagement';
import InstructorManagement from './adminpages/InstructorManagement';
import CourseApproval from './adminpages/CourseApproval';
import GroupManagement from './adminpages/GroupManagement';
import ReportsAnalytics from './adminpages/ReportsAnalytics';
import BillingPayments from './adminpages/BillingPayments';
import AccessControl from './adminpages/AccessControl';
import CourseAssignment from './adminpages/Courseassignment';
import AdminMasterPage from './adminpages/Createmaster';
import CategoryPage from './adminpages/Master/Master/Createcategory';
import DesignationManager from './adminpages/Master/Master/CreateDegination';
import EducationManager from './adminpages/Master/Master/CreateEducation';
import OccupationManager from './adminpages/Master/Master/createOccupation';
import DepartmentManager from './adminpages/Master/Master/CreateDepartment';
import SubdivisionManager from './adminpages/Master/Master/CreateSubdivion';
import DivisionManager from './adminpages/Master/Master/CreateDivison';
import TmsDashboard from './TmsPages/TmsDashboard';
import AdminSetting from './adminpages/AdminSetting';
import AdminEditProfile from './adminpages/AdminEditProfile';

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();

  // Derive active page from the last URL segment
  const pathSegments = location.pathname.split('/');
  const activeMenu = pathSegments[pathSegments.length - 1] || 'dashboard';

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleMenuClick = (menuId) => {
    navigate(`/db-shiksha/kaas/admin/${menuId}`);
  };

  const renderContent = () => {
    switch (activeMenu) {
      case 'dashboard':
      case 'lmsAdminDashboard':
        return <Dashboard />;
      case 'tmsdashboard':
        return <TmsDashboard />;
      case 'user-management':
        return <UserManagement />;
      case 'course-assignment':
        return <CourseAssignment />;
      case 'instructor-management':
        return <InstructorManagement />;
      case 'admin-master':
        return <AdminMasterPage />;
      case 'create-category':
        return <CategoryPage />;
      case 'create-occupation':
        return <OccupationManager />;
      case 'create-department':
        return <DepartmentManager />;
      case 'create-designation':
        return <DesignationManager />;
      case 'create-division':
        return <DivisionManager />;
      case 'create-subdivision':
        return <SubdivisionManager />;
      case 'create-education':
        return <EducationManager />;
      case 'course-approval':
        return <CourseApproval />;
      case 'group-management':
        return <GroupManagement />;
      case 'reports-analytics':
        return <ReportsAnalytics />;
      case 'billing-payments':
        return <BillingPayments />;
      case 'access-control':
        return <AccessControl />;
      case 'settings':
        return <AdminSetting />;
      case 'profile':
        return <AdminEditProfile />;
      default:
        return <Dashboard />;
    }
  };

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        height: '100vh', 
        overflow: 'hidden',
        bgcolor: 'background.default',
        fontFamily: "'Outfit', sans-serif"
      }}
    >
      <Sidebar 
        activeMenu={activeMenu} 
        setActiveMenu={handleMenuClick}
        isOpen={sidebarOpen}
        toggleSidebar={toggleSidebar}
      />
      <Box 
        sx={{ 
          flex: 1, 
          display: 'flex', 
          flexDirection: 'column',
          overflow: 'hidden',
          transition: theme.transitions.create(['all'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }}
      >
        <Navbar />
        <Box 
          component="main" 
          sx={{ 
            flex: 1, 
            padding: '24px', 
            overflowY: 'auto',
            bgcolor: 'background.default',
          }}
        >
          {renderContent()}
        </Box>
      </Box>
    </Box>
  );
}

export default App;
